module.exports = __webpack_public_path__ + "static/media/link-externo-roxo.04251b72.svg";